<template>
  <div>
    <div v-for="(action, index) in actions" :key="index" class="inline-block pl-4">
      <button
        class="text-left p-3 w-full"
        ref="option"
        @click="handleAction(action.action)"
      >
        {{ action.label }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavigationContextOpen",
  props: {
    icon: {
      type: String
    },
    iconSize: {
      type: String,
      default: "medium",
      validator: value => {
        return ["large", "medium", "small", "mini"].indexOf(value) !== -1;
      }
    },
    label: {
      type: String
    },
    ariaLabel: {
      type: String
    },
    more: {
      type: Boolean
    },
    actions: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isOpen: false,
      tabIndex: 0,
      focus: false
    };
  },
  watch: {
    focus(newVal) {
      if(newVal === false) {
        this.isOpen = !this.isOpen;
      }
    }
  },
  methods: {
    handleAction(action) {
      this.isOpen = false;
      this.$store.commit('SET_BUTTON', this.buttonId);
      this.$emit("click", {
        action: action
      });
    }
  },
  computed: {
    buttonId() {
      return `id${Math.random()}`;
    }
  }
};
</script>

<style lang="scss" scoped>
button {
  @apply inline-block cursor-pointer text-blue-900 font-sans font-semibold select-none w-full py-2 px-3 rounded border-2 text-blue-900 bg-gray-400 border-blue-900 text-left leading-snug w-auto py-3 text-base;
  max-height: 44px;
  &:focus {
    outline: 1px solid #041e42;
    outline-offset: 3px;
  }
  @screen md {
    @apply w-auto;
  }
}
</style>
